export default __webpack_public_path__ + "static/media/medications2.db97a726.jpeg";